/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Education_DescriptionInputs */

const en_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software engineering fundamentals, algorithms, data structures & modern web tech.`)
};

const ar_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أساسيات هندسة البرمجيات والخوارزميات وهياكل البيانات وتقنيات الويب الحديثة.`)
};

const bn_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ইঞ্জিনিয়ারিং ফান্ডামেন্টাল, অ্যালগরিদম, ডেটা স্ট্রাকচার ও আধুনিক ওয়েব টেক।`)
};

const de_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software-Engineering-Grundlagen, Algorithmen, Datenstrukturen und moderne Web-Technologie.`)
};

const es_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundamentos de ingeniería de software, algoritmos, estructuras de datos y tecnología web moderna.`)
};

const fr_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondamentaux du génie logiciel, algorithmes, structures de données et technologie Web moderne.`)
};

const pt_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundamentos de engenharia de software, algoritmos, estruturas de dados e tecnologia web moderna.`)
};

const zh_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件工程基础知识、算法、数据结构和现代网络技术。`)
};

const tr_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım mühendisliğinin temelleri, algoritmalar, veri yapıları ve modern web teknolojisi.`)
};

const ru_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основы разработки программного обеспечения, алгоритмы, структуры данных и современные веб-технологии.`)
};

const pl_education_description = /** @type {(inputs: Education_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podstawy inżynierii oprogramowania, algorytmy, struktury danych i nowoczesne technologie internetowe.`)
};

/**
* | output |
* | --- |
* | "Software engineering fundamentals, algorithms, data structures & modern web tech." |
*
* @param {Education_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const education_description = /** @type {((inputs?: Education_DescriptionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Education_DescriptionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_education_description(inputs)
	if (locale === "bn") return bn_education_description(inputs)
	if (locale === "de") return de_education_description(inputs)
	if (locale === "es") return es_education_description(inputs)
	if (locale === "fr") return fr_education_description(inputs)
	if (locale === "pt") return pt_education_description(inputs)
	if (locale === "zh") return zh_education_description(inputs)
	if (locale === "tr") return tr_education_description(inputs)
	if (locale === "ru") return ru_education_description(inputs)
	if (locale === "pl") return pl_education_description(inputs)
	return en_education_description(inputs)
});